"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalExplain_1 = __importDefault(require("../../../components/modal/ModalExplain"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const regex = /^[a-zA-Z0-9_]{4,15}$/;
const ChangeIDScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [visibleEmail, setVisibleEmail] = (0, react_1.useState)(false);
    const [errEmail, setErrorEmail] = (0, react_1.useState)("");
    const [email, setEmail] = (0, react_1.useState)('');
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setEmail(dataUser?.user_handle || '');
    }, [dataUser]);
    const validate = async () => {
        react_native_1.Keyboard.dismiss();
        if (dataUser?.contract_type != 2)
            return;
        const newUserHandle = email.trim();
        if (!newUserHandle) {
            return setErrorEmail("新しいユーザーIDは必須項目です。");
        }
        if (!regex.test(newUserHandle)) {
            return setErrorEmail("有効なユーザーIDを入力してください");
        }
        const data = new FormData();
        data.append("user_handle", newUserHandle);
        setLoading(true);
        User_1.default.updateProfile(data)
            .then(() => {
            dispatch((0, slice_2.updateUserHandleAction)(newUserHandle));
            dispatch(slice_1.default.actions.showToast("ユーザーIDを変更しました"));
        })
            .catch(err => {
            if (err?.response?.data?.error?.code === "INVALID_PARAMETERS") {
                setErrorEmail("新しいユーザーIDの値は既に存在しています。");
            }
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const onChangeText = (text) => {
        setEmail(text);
        setErrorEmail("");
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                }, title: "ユーザーID変更", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30E6\u30FC\u30B6\u30FC\u540D\u5909\u66F4")),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            marginTop: 12,
                        } }, "\u65B0\u3057\u3044\u30E6\u30FC\u30B6\u30FCID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginBottom: (0, scale_1.scale)(24) } },
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u7121\u6599\u4F1A\u54E1\u306E\u65B9\u306F\u30E6\u30FC\u30B6\u30FCID\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002")),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: "#292A33",
                        } }, "\u73FE\u5728\u306E\u30E6\u30FC\u30B6\u30FCID"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: "#292A33",
                            marginTop: (0, scale_1.scale)(8),
                        } },
                        "@",
                        dataUser?.user_handle),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.loginForm },
                        react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, display: dataUser?.contract_type == 2, inputStyle: { color: "#545454" }, inputContainerStyle: { backgroundColor: "#DDDDDD" }, label: "新しいユーザーID", value: email, maxLength: 50, onChangeText: onChangeText, errorText: errEmail }),
                        react_1.default.createElement(react_native_1.View, { style: { width: "100%", marginTop: (0, scale_1.scale)(8) } },
                            react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "\u203B"),
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "4\u6587\u5B57\u301C15\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                            react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "\u203B"),
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "\u82F1\u5B57\u306E\u5927\u6587\u5B57\u3068\u5C0F\u6587\u5B57\u306F\u533A\u5225\u3055\u308C\u307E\u3059\u3002")),
                            react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "\u203B"),
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                        fontSize: (0, scale_1.moderateScale)(12),
                                        lineHeight: (0, scale_1.moderateScale)(18),
                                        color: "#545454",
                                    } }, "\u4F7F\u3048\u308B\u6587\u5B57\u306F\u82F1\u6570\u5B57\uFF08a-z, A-Z, 0-9\uFF09\u3001\u30A2\u30F3\u30C0\u30FC\u30B9\u30B3\u30A2\uFF08_\uFF09\u3067\u3059\u3002"))),
                        react_1.default.createElement(components_1.LinearButton, { title: "\u4FDD\u5B58", style: {
                                width: '100%',
                                height: (0, scale_1.scale)(48),
                                borderRadius: (0, scale_1.scale)(4),
                            }, fontWeight: "600", textStyle: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: '#FEFEFE'
                            }, disabled: dataUser?.contract_type != 2, containerStyle: { marginTop: (0, scale_1.scale)(32), width: '100%' }, onPress: validate }))))),
        react_1.default.createElement(ModalExplain_1.default, { visible: visibleEmail, onClose: () => {
                setVisibleEmail(false);
            }, title: "Fujisan ID\u306B\u3064\u3044\u3066", content: "\u6295\u8CC7\u306E\u5148\u8F29\u3067\u306F\u3001\u682A\u5F0F\u4F1A\u793E\u5BCC\u58EB\u5C71\u30DE\u30AC\u30B8\u30F3\u30B5\u30FC\u30D3\u30B9\u304C\u63D0\u4F9B\u3057\u3066\u3044\u308B Fujisan ID \u3092\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = ChangeIDScreen;
